import { Skeleton } from "@/components/ui/skeleton";

export const TestimonialCardSkeleton = () => {
  return (
    <div className="flex flex-row gap-x-28">
      {/* Quote image skeleton - hidden on mobile */}
      <Skeleton className="hidden size-28 shrink-0 rounded-lg lg:block" />

      {/* Main content */}
      <div className="flex w-full flex-col gap-y-6 lg:gap-y-12">
        {/* Rating stars */}
        <div className="flex items-center">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} className="mr-2 size-4 rounded-full lg:size-8" />
          ))}
          <Skeleton className="ml-3 h-6 w-16 rounded-md lg:h-10" />
        </div>

        {/* Testimonial text */}
        <div className="space-y-2">
          <Skeleton className="h-6 w-full rounded-md lg:h-10" />
          <Skeleton className="h-6 w-4/5 rounded-md lg:h-10" />
          <Skeleton className="h-6 w-3/4 rounded-md lg:h-10" />
        </div>

        {/* Author info */}
        <div className="flex items-center gap-x-4">
          <Skeleton className="size-16 shrink-0 rounded-full lg:size-20" />
          <div className="flex w-full flex-col gap-y-1 lg:gap-y-2">
            <Skeleton className="h-6 w-32 rounded-md lg:h-8 lg:w-48" />
            <Skeleton className="h-5 w-48 rounded-md lg:h-6 lg:w-64" />
          </div>
        </div>
      </div>
    </div>
  );
};
